import DOMPurify from "isomorphic-dompurify";
import Markdown from "markdown-to-jsx/react";

/**
 * Renders markdown after DOMPurify sanitization.
 * Prefer this over raw markdown-to-jsx for CMS / user content.
 */
export default function SafeMarkdown({ children, options, className, ...rest }) {
  if (children == null || children === "") return null;

  const sanitized = DOMPurify.sanitize(String(children));

  return (
    <Markdown options={options} className={className} {...rest}>
      {sanitized}
    </Markdown>
  );
}
